"use strict";

require("core-js/modules/es.array.iterator");

var tap = require("./tap.js");

var log = require("./log.js");

const f = tap(log);
module.exports = hi;

function hi(..._) {
  return f(..._);
}